var map = {
	"./grid_blue.png": "bfb0",
	"./grid_classic.png": "0c9f",
	"./grid_disable.png": "6ec2",
	"./grid_green.png": "7679",
	"./grid_orange.png": "9098",
	"./grid_purple.png": "b359"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c352";